module.exports = __webpack_public_path__ + "img/payment-logos-visa.16e584f0.png";